import { Button } from "@/components/ui/button";
import { useWorkspaceData } from "@/hooks/use-workspace-data";
/**
 * Refresh notice — shown above the workspace grid when the bootstrap data
 * is more than N seconds old, so users know a refresh is overdue.
 */
import { AlertCircle, RefreshCw } from "lucide-react";

export interface WorkspaceRefreshNoticeProps {
  /** Stale threshold in milliseconds. Default: 5 minutes. */
  staleAfterMs?: number;
}

export function WorkspaceRefreshNotice({
  staleAfterMs = 5 * 60 * 1000,
}: WorkspaceRefreshNoticeProps): JSX.Element | null {
  const lastFetchedAt = useWorkspaceData((s) => s.lastFetchedAt);
  const fetchWorkspace = useWorkspaceData((s) => s.fetch);
  const loading = useWorkspaceData((s) => s.loading);

  if (!lastFetchedAt) return null;
  if (Date.now() - lastFetchedAt < staleAfterMs) return null;

  return (
    <div className="flex items-center justify-between gap-2 rounded-md border border-border bg-muted/40 px-3 py-2 text-sm">
      <div className="flex items-center gap-2 text-muted-foreground">
        <AlertCircle className="h-4 w-4" />
        <span>Workspace data may be out of date.</span>
      </div>
      <Button variant="outline" size="sm" onClick={() => void fetchWorkspace()} disabled={loading}>
        <RefreshCw className={`mr-1 h-4 w-4 ${loading ? "animate-spin" : ""}`} />
        Refresh
      </Button>
    </div>
  );
}
